/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Marca {
  constructor () {
    this.marca_id = uuidV4()
    this.descr = ''
  }
}
